module.exports = __webpack_public_path__ + "assets/img/ice.154eb484.png";